

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { BcEhtSetup } from "../../components/BcEhtSetup";


export const BcEhtSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="EHT British Columbiap"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: "Company", navigateTo: "/company/BcEht/list" },
        { text: "EHT British Columbia", navigateTo: "/company/BcEht/setup" }
      ]}
      mainContents={<BcEhtSetup />}
    />
  );
};
